<template>
  <div class="leaderboard-head">
    <div
      :inner-html.prop="titleHTML"
      class="final-title"
    />
    <div
      v-if="isAnsweredAtLeastOne"
      v-html="answerStatText"
      class="final-stat"
    />
    <div
      v-if="!isAnsweredAtLeastOne"
      v-html="noQuizAnsweredText"
      class="final-rank"
    />
    <div
      v-if="isAnsweredAtLeastOne"
      v-html="$t('final_ranking', {
        ranking: ranking
      })"
      class="final-rank"
    />
    <div
      v-if="isShowCTA"
      class="section-cta"
    >
      <button @click="viewMyAnswers">
        {{ $t('view_answers') }}
      </button>
    </div>
  </div>
</template>

<script>
import util from '@/util'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    currentQuiz: {
      type: Number,
      default: 1,
    },
    presentationID: {
      type: Number,
      default: null,
    },
    isShowAudiencePacingNextSlide: {
      type: Boolean,
      default: false,
    },
    lastSlide: {
      type: Boolean,
      default: false,
    },
    isFinalLeaderboard: {
      type: Boolean,
      default: false,
    },
    titleHTML: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'individual',
      validator: (value) => ['individual', 'team'].includes(value),
    },
  },
  computed: {
    audienceData() {
      return this.data && this.data.audience
    },
    correctAnswers() {
      return this.audienceData && this.audienceData.correctAnswerCount
    },
    correctRate() {
      return this.audienceData && Math.round(this.audienceData.correctRate * 100)
    },
    currentPosition() {
      return this.data && this.data.indexFormat
    },
    audiencesCount() {
      return this.data && this.data.audiencesCount
    },
    ranking() {
      return `${this.currentPosition} / ${this.audiencesCount}`
    },
    isAnsweredAtLeastOne() {
      return this.data && this.data.index !== undefined
    },
    answerStatText() {
      const statText = this.type === 'team'
        ? 'final_team_answers_stat'
        : 'final_answers_stat'

      return this.$t(statText, {
        correctAnswers: this.correctAnswers,
        totalQuiz: this.currentQuiz,
        correctRate: this.correctRate,
      })
    },
    noQuizAnsweredText() {
      const textKey = this.type === 'team'
        ? 'team_no_quiz_answered'
        : 'personal_no_quiz_answered'

      return this.$t(textKey)
    },
    isShowCTA() {
      return this.isFinalLeaderboard && this.isAnsweredAtLeastOne
    },
  },
  methods: {
    viewMyAnswers() {
      this.$router.push({
        name: 'lookback',
        params: {
          id: this.$store.state.presentation.uniqueAccessCode,
        },
        query: {
          'lookback-tab': 'answers',
        },
      })

      util.ga4Track('Leaderboard > View Answer', {
        presentationId: this.presentationID,
        eventLabel: 'Lookback',
        eventCategory: 'Audience',
      })
    },
  },
}
</script>
<style lang="scss">
.final-title {
  p {
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped>
.leaderboard-head {
  margin-bottom: 24px;
}

.final-title {
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 12px;
}

.final-stat {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.final-rank {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.section-cta {
  text-align: center;

  button {
    display: inline-block;
    padding: 9px 40px;
    min-width: 190px;
    color: #4b4b4b;
    background-color: #fff;
    border-radius: 26px;
    border: 1px solid var(--base-50, #D1D1D1);
    cursor: pointer;
    font-weight: 700;
    transition: 0.2s all ease;

    @media screen and (min-width: 1280px) {
      &:hover {
        color: #fff;
        border-color: #F4F4F4;
        background-color: #6298EB;
      }
    }
  }
}

.audience-pacing-next-action {
  margin-top: 12px;

  button {
    padding-left: 40px;
    padding-right: 40px;
    min-width: 190px;
  }
}
</style>
